export * from './specials.component';
